<template>
  <base-dialog @cancel="cancelDialog" :width="400" :modalProps="{ centered: true }">
    <div slot="header">{{$t('scope.text_416')}}</div>
    <div slot="body">
      <a-form :form="form.fc">
        <a-form-item v-bind="formItemLayout">
          <a-input class="material-input" v-decorator="decorator.captcha" :placeholder="$t('auth.captcha.placeholder')">
            <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, .25)" />
            <template>
              <a-icon v-show="form.fi.captchaLoading" slot="suffix" type="loading" style="color: rgba(0, 0, 0, .25)" />
              <img v-show="!form.fi.captchaLoading" class="captcha-img" slot="suffix" :src="form.fi.captchaImg" @load="captchaLoadHandle" @error="captchaErrorHandle" @click="fetchCaptcha" />
            </template>
          </a-input>
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('scope.send_verification_code') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'WebSmsCodeDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const captchaValidator = (rule, value, callback) => {
      const msg = this.$t('scope.text_417')
      if (value.length !== 4) {
        callback(msg)
        return
      }
      callback()
    }
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
        fi: {
          captchaImg: '',
          captchaLoading: false,
        },
      },
      decorator: {
        captcha: [
          'captcha',
          {
            validateFirst: true,
            // validateTrigger: 'submit',
            rules: [
              { required: true, message: this.$t('scope.text_337') },
              { validator: captchaValidator },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 19,
        },
        labelCol: {
          span: 5,
        },
      },
      responesData: '',
    }
  },
  async created () {
    this.loading = true
    try {
      this.fetchCaptcha()
      this.loading = false
    } catch (error) {
      this.loading = false
    }
  },
  methods: {
    fetchCaptcha () {
      this.form.fi.captchaLoading = true
      const epochstr = +new Date()
      this.captchaImg = ''
      const url = '/api/v2/register/captcha?rand=' + epochstr
      this.form.fi.captchaImg = url
    },
    captchaErrorHandle () {
      this.form.fi.captchaLoading = false
    },
    captchaLoadHandle () {
      this.form.fi.captchaLoading = false
    },
    async captchaValidator (captcha) {
      try {
        let data = {}
        if (this.params.resource && this.params.resource === 'resetcode') {
          data = {
            captcha,
            account: this.params.account,
          }
        } else {
          data = {
            captcha,
            mobile: this.params.mobile,
            email: this.params.email,
          }
        }
        const res = await this.$http.post(`/v2/register/${this.params.resource ? this.params.resource : 'activatecode'}`, data)
        if (res.data.code === 200) {
          this.responesData = res.data
          let to = ''
          if (this.responesData.to) {
            to = `(${this.responesData.to})`
          }
          this.$message.success(this.$t('scope.text_418') + to, 10)
        }
      } catch (error) {
        this.form.fc.resetFields(['captcha'])
        throw error
      }
    },
    async handleConfirm () {
      this.loading = true
      try {
        const { captcha } = await this.form.fc.validateFields()
        await this.captchaValidator(captcha)
        this.loading = false
        if (this.params.success && R.is(Function, this.params.success)) {
          this.params.success(this.responesData)
        }
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.captcha-img {
  height: 28px;
  width: 98px;
}
</style>
